import { CFTextReviewItem } from "@ui/cf-text-review/cf-text-review.component";
import { DateTime, Interval } from "luxon";

export class TimelineEntry {
    type = 1;                   // 1 - education, 2 - work
    startDate: DateTime;        // YYYYMM? have as number instead?
    endDate: DateTime;          // may be empty? or set to 'today' or 999912 by the server?
    startDateDisplay: string;
    endDateDisplay: string;
    title: string;
    description: string;
    id: number;
    duration = 0;
    note?: string;
    constructor(type: number, startDate: DateTime, startDateDisplay: string, endDate: DateTime, endDateDisplay: string, title: string, description: string, note?: string) {
        this.id = TimelineEntry.nextId++;
        this.type = type;
        this.startDate = startDate;
        this.startDateDisplay = startDateDisplay;
        this.endDate = endDate;
        this.endDateDisplay = endDateDisplay;
        this.title = title;
        this.description = description;
        this.note = note;
        this.calculateDuration();
    }

    calculateDuration(): void {
        const i = Interval.fromDateTimes(this.startDate, this.endDate);
        this.duration = +i.length('months');
    }


    static nextId = 0;
}

export class TimelineGap {
    startIndex = -1;
    endIndex = -1;
    gapLength = 0;
    constructor(start: number, end: number, length: number) {
        this.startIndex = start;
        this.endIndex = end;
        this.gapLength = length;
    }
}

export class GapEntry {
    id = 0;
    type = 0;
    name = '';
    html = '';
    extra?: string;
    reviewItem?: CFTextReviewItem;
    constructor(name: string, type: number, html: string, extra?: string) {
        this.name = name;
        this.id = GapEntry.nextId++;
        this.type = type;
        this.html = html;
        this.extra = extra;
    }

    static nextId = 0;
}

export class TimelineDetails {
    today = DateTime.now().toFormat('yyyy-MM');
    from: DateTime = DateTime.now();
    to: DateTime = DateTime.now();
    months = 0;

    gaps: TimelineGap[] = [];

    entriesPerMonth = new Map<number, TimelineEntry[]>();
    gapDisplay: GapEntry[] = [];
}